<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header="getHeader()" @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-polish');
        },
        getLayout() {
            let layout = {
                default: [
                    '\u0105 \u0107 \u0119 \u0142 \u0144 \u00f3 \u015b \u017a \u017c',
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
